<script>
import { appConfig } from '../../config.js'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      remember: true,
      showNewLogin: true,
      eyeIcon: true,
      passType: 'password'
    }
  },
  computed: {
    isLoggedIn () {
      return Boolean(this.$store.state.token && this.$store.state.token !== undefined && this.$store.state.token !== 'undefined' && this.$store.state.token.length > 1)
    },
    isHideOldLogin () {
      return false
    },
  },
  mounted () {
    if (this.isLoggedIn) {
      console.log('MOUNTED-REDIRECT: /')
      this.$router.push('/')
    } else if (this.isHideOldLogin) {
      console.log('MOUNTED-REDIRECT-HOME', this.isHideOldLogin)
      document.location.replace(appConfig.homeURL + '/')
    }
  },
  methods: {
    auth () {
      this.$nextTick(() => {
        this.$store.dispatch('loadMenu')
        this.$store.dispatch('loadUserInfo')
            .then(async () => {
              await this.$store.dispatch('loadVendorInfo')
              this.$store.dispatch('aiCredits/getAiCredits')
              this.$store.dispatch('loadDashboardSummary')
              this.$store.dispatch('loadCEStatuses')
              this.$store.dispatch('dashboard/loadNotices')
              this.$store.dispatch('card/loadCards', { page: 1, withTimestamp: false })
              this.$store.dispatch('estimate/loadEstimates', { page: 1, withTimestamp: false })
              this.$store.dispatch('invoice/loadInvoices', { page: 1, withTimestamp: false })
              this.$store.dispatch('dashboard/loadData', {isShowNProgress: false})
              if (!this.$store.getters.isFreePlan) {
                this.$store.dispatch('board/loadInBoard', { page: 1, withTimestamp: false })
                this.$store.dispatch('board/loadDepartureBoard', { page: 1, withTimestamp: false })
              }
            })
            .then(() => {
              if (this.isBusinessTypeBikeRepairer) {
                this.$store.dispatch('loadVehicleMakeModelsBike')
              }else if (this.isBusinessTypeCaravanRepairer) {
                this.$store.dispatch('loadVehicleMakeModelsCaravan')
              } else {
                this.$store.dispatch('loadVehicleMakeModels')
              }
              this.$store.dispatch('loadVehicleScheduleNumbers')
              this.$store.dispatch('loadButterfly')
              this.$store.dispatch('loadUsers')
              this.$store.dispatch('loadBusinessTypes')
              this.$store.dispatch('loadCustomerVehicles')
              this.$store.dispatch('loadPartsSearchLocation')
              this.$store.dispatch('report/loadReports')
            })
            .catch(error => console.log(error))
      })
    },
    onClickSignUp () {
      this.$router.push('/register')
    },
    onClickForgotUsername () {
      this.$router.push('/auth/forgot/username')
    },
    onClickForgotPassword () {
      this.$router.push('/auth/forgot/password')
    },
    login: function () {
      const username = this.username
      const password = this.password
      const remember = this.remember
      NProgress.start()
      this.$store.dispatch('login', { username, password, remember }).then(() => {
        this.auth()
        NProgress.done()
        this.$router.push('/')
      })
          .catch(error => {
            NProgress.done()
          })
    },
    openPass () {
      if(this.eyeIcon) {
        this.passType = 'text'
        this.eyeIcon = false
      } else {
        this.passType = 'password'
        this.eyeIcon = true
      }
    },
  }
}
</script>

<template>
  <div>
    <div v-if="false" class="container-fluid bg-white p-0 login">
      <div class="header mb-2">
        <div class="gradient auth-bg"></div>
        <div class="h-content">
          <div class="row clearfix">
            <div class="col-md-6 mt-1 mb-3">
              <div class="main-logo">
                <router-link to="/login" class="logo-link"></router-link>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-7 col-lg-6 col-md-4"></div>
              <div class="col-xl-5 col-lg-6 col-md-6">
                <div class="box box-block mb-3 col-md-6 registration-block">
                  <form class="form-material" method="POST" @submit.prevent="login">
                    <div class="form-group">
                      <div class="input-group">
                        <input type="text" class="form-control" name="username" placeholder="Username" v-model="username">
                      </div>
                      <div class="w-100 text-right mb-1.t">
                        <a href="" @click.prevent="onClickForgotUsername">Forgot your Username?</a>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="input-group">
                        <input type="password" class="form-control text-white" name="password" placeholder="Password"
                               v-model="password">
                      </div>
                    </div>
                    <div class="form-group clearfix mt-2">
                      <div>
                        <label class="pin-job left-element ">
                          <input type="checkbox" v-model="remember" style="margin-left: 4px;  visibility: hidden;"/>
                          <span class="pin_content pin-checkmark repair-fixed" style="top: 0px; left: 1px;"><i
                              class='bx bx-check'></i></span>
                          <span class="custom-control-description">Remember me</span>
                        </label>
                        <div class="float-xs-right">
                          <a href="" @click.prevent="onClickForgotPassword">Forgot your Password?</a>
                        </div>

                      </div>
                      <div class="float-xs-right">
                        <label class="custom-control custom-checkbox">
                          <span class="custom-control-description">Terms &amp; Conditions</span>
                        </label>
                      </div>
                    </div>
                    <div class="form-group mt-2 mb-1">
                      <button type="submit" class="btn btn-outline-primary btn-block btn-lg b-a-radius-0-25">Sign in
                      </button>
                    </div>
                  </form>
                  <!--                                    <div class="row">-->
                  <!--                                        <div class="col-xs-6">-->
                  <!--                                            <button type="button" class="btn bg-facebook btn-block label-left btn-lg b-a-radius-0-25">-->
                  <!--                                                <span class="btn-label"><i class="ti-facebook"></i></span>-->
                  <!--                                                Facebook-->
                  <!--                                            </button>-->
                  <!--                                        </div>-->
                  <!--                                        <div class="col-xs-6">-->
                  <!--                                            <button type="button" class="btn bg-googleplus btn-block label-left btn-lg b-a-radius-0-25">-->
                  <!--                                                <span class="btn-label"><i class="ti-google"></i></span>-->
                  <!--                                                Google+-->
                  <!--                                            </button>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <div class="row">
                    <div class="col-xs-12 mt-3">
                      <p class="text-sm-center">Do not have an account? <a href="" @click.prevent="onClickSignUp">Sign Up
                        Today Free</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- End of container -->
      </div><!-- End of header -->
      <!--        <div class="container">&lt;!&ndash; Start of container - new addition &ndash;&gt;-->
      <!--            <div class="col-lg-4 col-md-6 col-xs-12">-->
      <!--                <div class="box box-block bg-white tile tile-1 mb-2">-->
      <!--                    <div class="t-icon right"><span class="bg-theme"></span><i class="ti-package"></i></div>-->
      <!--                    <div class="t-content">-->
      <!--                        <h6 class="text-uppercase mb-1"><a href="/" alt="" title=""/>Latest Products</a></h6>-->
      <!--                        <h5 class="mb-1">Product Name</h5>-->
      <!--                        <div class="text-xl-center img-wrap">-->
      <!--                            <a href="/"/><img src="/img/photos-3/tool.jpg" alt="" title="" class="img-fluid img-thumbnail mb-2"/></a>-->
      <!--                            <span class="clearfix"></span>-->
      <!--                        </div>-->
      <!--                        <span> </span>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--            <div class="col-lg-4 col-md-6 col-xs-12">-->
      <!--                <div class="box box-block bg-white tile tile-1 mb-2">-->
      <!--                    <div class="t-icon right"><span class="bg-theme"></span><i class="ti-announcement"></i></div>-->
      <!--                    <div class="t-content">-->
      <!--                        <h6 class="text-uppercase mb-1"><a href="/" alt="" title=""/>In the News</a></h6>-->
      <!--                        <h5 class="mb-1 text-truncate">News Title goes here Lorem ipsum sin dolor</h5>-->
      <!--                        <div class="news-list pt-0-5 pr-0-5 mb-3">-->
      <!--                            <div class="mb-1">-->
      <!--                                Sept <span class="tag tag-danger mr-0-5 mb-0-5"> 12th </span>-->
      <!--                                <span class="clearfix"></span>-->
      <!--                                <span class="font-90">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae odio eu velit scelerisque aliquet. Aliquam vitae tempus diam. </span>-->
      <!--                            </div>-->
      <!--                            <div class="mb-2">-->
      <!--                                Sept <span class="tag tag-danger mr-0-5 mb-0-5"> 12th </span>-->
      <!--                                <span class="clearfix"></span>-->
      <!--                                <span class="font-90">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae odio eu velit scelerisque aliquet. Aliquam vitae tempus diam. </span>-->
      <!--                            </div>-->
      <!--                            <div class="mb-2">-->
      <!--                                Sept <span class="tag tag-danger mr-0-5 mb-0-5"> 12th </span>-->
      <!--                                <span class="clearfix"></span>-->
      <!--                                <span class="font-90">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae odio eu velit scelerisque aliquet. Aliquam vitae tempus diam. </span>-->
      <!--                            </div>-->
      <!--                        </div>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--            <div class="col-lg-4 col-md-6 col-xs-12">-->
      <!--                <div class="box box-block bg-white tile tile-1 mb-2">-->
      <!--                    <div class="t-icon right"><span class="bg-theme"></span><i class="ti-mouse-alt"></i></div>-->
      <!--                    <div class="t-content">-->
      <!--                        <h6 class="text-uppercase mb-1"><a href="/" alt="" title=""/>Advertise here</a></h6>-->
      <!--                        <h5 class="mb-1">Benefits</h5>-->
      <!--                        <span> </span>-->
      <!--                        <button class="btn btn-outline-primary mt-2">Online Application Form</button>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->

      <!--        </div>&lt;!&ndash; End of container &ndash;&gt;-->
    </div>
    <div v-if="true" style="background-color: #F4F6F8; display: flex;justify-content: center;align-items: center;min-height: 100vh;padding: 20px;">
      <main class="login-container">
        <header class="login-header">
          <img src="@/assets/logos/logo.png" alt="RepairShop Logo" class="brand-logo" width="200" height="auto">
          <p>Please log in to your account</p>
        </header>

        <!-- Added novalidate to handle validation via custom JS -->
        <div id="loginForm" class="login-form" novalidate>

          <!-- Global Error Alert Container -->
          <div id="globalError" class="error-message" role="alert"></div>

          <!-- Username: Added autocomplete attribute -->
          <div class="input-group">
            <label for="username">Username</label>
            <input type="text" v-model="username"
                   id="username"
                   name="username"
                   placeholder="Enter your username"
                   autocomplete="username" required>
          </div>

          <!-- Password: Added autocomplete attribute -->
          <div class="input-group">
            <label for="password">Password</label>
            <div class="password-wrapper">
              <input v-model="password"
                     :type="passType"
                     id="password"
                     name="password"
                     placeholder="Enter your password"
                     autocomplete="current-password"
                     required>

              <button @click="openPass" type="button" id="togglePassword" class="toggle-password" aria-label="Show password" aria-pressed="false" tabindex="-1">
                <svg v-if="eyeIcon" id="eyeIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <svg v-else id="eyeIcon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                  <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>
              </button>
            </div>
          </div>

          <!-- Remember Me & Links -->
          <div class="form-options">
            <div class="remember-me">
              <input v-model="remember" type="checkbox" id="rememberMe" name="rememberMe">
              <label for="rememberMe">Remember me</label>
            </div>

            <div class="forgot-links">
              <a href="" @click.prevent="onClickForgotUsername" class="forgot-link">Forgot my username?</a>
              <a href="" @click.prevent="onClickForgotPassword" class="forgot-link">Forgot my password?</a>
            </div>
          </div>

          <!-- Submit Button -->
          <button type="submit" id="loginBtn" class="login-btn" @click="login">
            <span id="btnText">Login</span>
            <div id="btnSpinner" class="spinner hidden" aria-hidden="true"></div>
          </button>

        </div>

        <footer class="disclaimer">
          This system is restricted to authorized RepairShop customers only. Unauthorized access or use is strictly prohibited.
        </footer>
      </main>

    </div>
  </div>


</template>

<style>
.V3 .login input {
  opacity: 1;
  color: #FFFFFF;
}

.V3 .login input:focus {
  color: #FFFFFF;
}

.V3 .login .form-control::placeholder {
  color: #FFFFFF;
  opacity: 0.5;
  font-size: 12px;
  line-height: 16px;
}

/* WebKit, Edge */
.V3 .login .form-control::-webkit-input-placeholder {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}

/* Firefox 4-18 */
.V3 .login .form-control:-moz-placeholder {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}

/* Firefox 19+ */
.V3 .login .form-control::-moz-placeholder {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}

/* IE 10-11 */
.V3 .login .form-control:-ms-input-placeholder {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}

/* Edge */
.V3 .login .form-control::-ms-input-placeholder {
  color: #FFFFFF;
  font-size: 12px;
  line-height: 16px;
}

</style>

<style>
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.login .logo {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  letter-spacing: 5px;
}

.login .gradient.auth-bg {
  background: #192742 url("../../assets/img/photos-3/bg-photo.png") no-repeat;
  background-size: cover;
}

.login .header .box {
  border: none;
  background: rgb(33, 35, 48);
  padding: 2rem;
  border-radius: 5px;
}

.login .header .box .form-material .form-control {
  background-image: linear-gradient(#DEE9FF, #DEE9FF), linear-gradient(rgba(255, 255, 255, 0.125), rgba(255, 255, 255, 0.125));
}

.form-material .form-control {
  padding: 0.5rem 0.75rem !important;
}

.login .header .box .bg-facebook:hover,
.login .header .box .bg-googleplus:hover {
  opacity: .7
}

.login .custom-checkbox .custom-control-indicator {
  border-radius: .125rem;
}

.checked.custom-control-indicator {
  color: #FFFFFF;
  background-color: #5D54EF;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}

.custom-control-input:focus ~ .custom-control-indicator {
  -webkit-box-shadow: 0 0 0 0.075rem #FFFFFF, 0 0 0 0.2rem #5E79FF;
  box-shadow: 0 0 0 0.075rem #FFFFFF, 0 0 0 0.2rem #5E79FF;
}

.custom-control-input:active ~ .custom-control-indicator {
  color: #FFFFFF;
  background-color: #5E78FF;
}

.login .forgot-pass {
  opacity: .5;
  font-weight: 100;
}

.login .btn-outline-primary {
  color: #FFFFFF;
  background-color: #5D54EF;
  border-color: #5E79FF;
}

.login .btn-outline-primary:hover,
.login .btn-outline-primary:active {
  background: #5E78FF;
  border-color: #5E78FF;
  color: #FFFFFF;
}

.login .t-content {
  height: 240px;
}

.login .t-content .img-wrap {
  display: inline-block;
  vertical-align: middle;
}

.login .t-content .img-fluid.img-thumbnail {
  height: 170px;
}

.login .bg-theme {
  background: #7A89A9;
}

.login .news-list {
  height: 200px;
  overflow-y: auto;
}


/* For 1x devices */
.main-logo {
  width: 212px;
  height: 54px;
  background-image: url('../../assets/logos/brandslogo.png');
  background-repeat: no-repeat;
}

/* For 2x devices */
@media only screen and ( -webkit-min-device-pixel-ratio: 2 ), only screen and ( -webkit-min-device-pixel-ratio: 1.5 ), only screen and ( -moz-min-device-pixel-ratio: 2), only screen and ( -o-min-device-pixel-ratio: 3/2), only screen and ( -o-min-device-pixel-ratio: 2/1), only screen and ( min--moz-device-pixel-ratio: 1.5), only screen and ( min-device-pixel-ratio: 1.5), only screen and ( min-device-pixel-ratio: 2) {
  .main-logo {
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .logo-link {
    display: block;
    height: 42px;
    width: 200px;
  }

  .header .btn {
    white-space: normal !important;
  }
}

@media screen and (max-width: 1200px) {
  .container {
    width: 1140px;
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 100% !important;
  }

  .header .gradient {
    display: none;
  }

  .header-block {
    background: #1f233d;
    height: 100px;
    width: 100vh;
    top: -13px;
  }

  .box-block {
    margin: 0 auto;
  }

  .header .h-content {
    padding: 0;
  }

  .logo-link {
    background-size: contain !important;
    background-repeat: no-repeat !important;
  }
}

/* For 3x devices */
@media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 480dpi) {
  .main-logo {
    background-image: url('../../assets/logos/logo3x.png');
    background-size: 100% auto;
  }
}


</style>

<style scoped>
.registration-block {
  width: 410px;
  right: 50px;
}

@media screen and (max-width: 768px) {
  .registration-block {
    right: 0;
  }
}

.pin-job {
  cursor: pointer;
}

.pin-checkmark {
  top: 145px;
  left: 28px;
  height: 16px;
  width: 16px;
}

.bx-check:before {
  content: "\ea0f";
}

input:checked ~ .pin-checkmark {
  background-color: #5D54EF;
  border-color: #5E79FF;
}

.pin-checkmark i {
  margin: auto;
  width: 16px;
  margin-top: 3px;
  display: none;
}

input:checked ~ .pin-checkmark i {
  display: block;
  font-size: 18px !important;
}

.custom-control-description {
  margin-left: 5px;
}


/* =========================================
   new login styles
   ========================================= */

.login-container {
  background-color: #FFFFFF;
  width: 100%;
  max-width: 420px;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(29, 43, 56, 0.08);
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.login-header { text-align: center; margin-bottom: 20px; }

.brand-logo {
  width: 100%;
  max-width: 200px;
  height: auto;
  margin: 0 auto 10px auto;
  display: block;
}

.login-header p {
  color: #616A75;
  font-size: 15px;
  margin-top: 15px;
}

/* =========================================
   FORM ELEMENTS
   ========================================= */
.login-form { display: flex; flex-direction: column; gap: 20px; }

.input-group { display: flex; flex-direction: column; gap: 6px; }

.input-group label {
  color: #1D2B38;
  font-size: 14px;
  font-weight: 600;
}

.input-group input:not([type="checkbox"]) {
  padding: 12px 16px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 16px;
  color: #1D2B38;
  outline: none;
  height: 44px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
}

.input-group input:not([type="checkbox"]):focus {
  border-color: #5D54EF;
  box-shadow: 0 0 0 3px rgba(93, 84, 239, 0.15);
}

/* Error State */
.input-group input.error {
  border-color: #DC2626;
  background-color: #FEF2F2;
}

.error-message {
  color: #DC2626;
  font-size: 0.8rem;
  display: none;
}

/* Password Wrapper & Toggle Icon */
.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.password-wrapper input { padding-right: 45px !important; }

.toggle-password {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #616A75;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  padding: 0;
}

.toggle-password:hover, .toggle-password:focus {
  color: #5D54EF;
  outline: none;
}

/* =========================================
   FORM OPTIONS & BUTTON
   ========================================= */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: -5px;
  font-size: 0.85rem;
}

.remember-me { display: flex; align-items: center; gap: 8px; margin-top: 4px; }

.remember-me input[type="checkbox"] {
  appearance: auto;
  accent-color: #5D54EF;
  width: 16px; height: 16px; cursor: pointer;
}

.remember-me label {
  color: #616A75;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  position: relative;
  top: 3px;
}

.forgot-links { display: flex; flex-direction: column; gap: 6px; align-items: flex-end; }

.forgot-link {
  color: #5D54EF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
  font-size: 13px;
}

.forgot-link:hover { color: #5E78FF; text-decoration: underline; }

.login-btn {
  background-color: #5D54EF;
  color: #FFFFFF;
  border: 1px solid #5E79FF;
  border-radius: 8px;
  padding: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  margin-top: 10px;
  height: 50px;
}

.login-btn:hover:not(:disabled),
.login-btn:active:not(:disabled) {
  background-color: #5E78FF;
  border-color: #5E78FF;
}

.login-btn:disabled { cursor: not-allowed; opacity: 0.8; }

.spinner {
  width: 20px; height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.hidden { display: none !important; }

@keyframes spin { to { transform: rotate(360deg); } }

/* =========================================
   DISCLAIMER & RESPONSIVENESS
   ========================================= */
.disclaimer {
  margin-top: 25px; padding-top: 20px;
  border-top: 1px solid #D1D5DB;
  font-size: 12px;
  color: #616A75;
  text-align: center; line-height: 1.5;
}

@media (max-width: 480px) {
  .login-container { padding: 30px 20px; }
  .form-options { flex-direction: column; gap: 15px; }
  .forgot-links { align-items: flex-start; }
}

</style>
